import { IStandardConfigItemDto } from "@app/shared/models/dtos/standard-config-item";
import { Validator } from 'fluentvalidation-ts';

export class StandardConfigItemDtoValidator extends Validator<IStandardConfigItemDto> {
  constructor() {
    super();
    this.ruleFor('QuantityTypeId')
      .must(s => s !== null && s > 0)
      .withMessage('QTY Type is required');

    this.ruleFor('Quantity')
      .must(s => s !== null && s !== undefined)
      .withMessage('Quantity is required')
      .when(
        s => s.QuantityTypeId === 1, 'AppliesToCurrentValidator'
      );

    this.ruleFor('EquationId')
      .must(s => s !== null && s > 0)
      .withMessage('Equation must be specified')
      .when(
        s => s.QuantityTypeId === 2, 'AppliesToCurrentValidator'
      );

  }
}